import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const PIXEL_ID = 'EAAVUPnyRAs8BRExE5REFyXG4Gz5jQJWLLYOQFA2HCxCW1o8TKKZAStXGqSARfq7R1PyAV0iYrvnXAzwMuTV0naem5MrL8lS5364DNJLhpAMDdIqhXsiVxgz4oqmfYqZCDUqqMAMC2ZAhud28DYRoxpZAnIEKnZAFgK7RN6ZBJ4v4hKUk0jXZBWjeJEhWdxC2SMgsQZDZD';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}